import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HomeIcon from "@mui/icons-material/Home";
import { Box, Grid, ListItemButton, Typography } from "@mui/material";
import * as React from "react";
import { ListStateIconTool } from "source/components/framework/List/ListStateIconTool";
import { EnumHelper, GroupPermissionLevel } from "ui/Scripts/source/models/enums";
import { IUnitNode } from "../../../../models/unit/unitNode";

export interface IUnitPermissionTreeProp {
    classes?: string;
    level?: number;
    unitNode: IUnitNode;
    selectedId?: string;
    isFirstNode: boolean;
    accessRightNoneTitle: string;
    accessRightReadTitle: string;
    accessRightWriteTitle: string;
    additionalPermissionTitle: string[];
    height?: string | number;
    getAdditionalPermissionInUse: (permission: number, additionalPermissionIndex: number) => boolean;
    onClick: (id: string) => void;
    onOpen: (id: string) => void;
}

export class UnitPermissionTree extends React.Component<IUnitPermissionTreeProp, {}> {
    handleUnitNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        props.onClick(props.unitNode.id);
    };
    
    handleUnitNodeDoubleClick = (e) => {
        const props = this.props;
        if (e) {
            e.stopPropagation();
        }
        props.onOpen(props.unitNode.id);
    };

    render() {
        const props = this.props;
        const unitNode = props.unitNode;
        if (!unitNode) return null;
        const hasChildren = unitNode.children.length > 0;
        const hasVisibleChildren = hasChildren;
        const isRoot = unitNode.getIsRoot();
        let selectedId = props.selectedId;
        if (!props.selectedId && isRoot) {
            selectedId = unitNode.id;
        }
        const permission = unitNode.permission.permission;
        const permissionText = (EnumHelper.isGreaterOrEqualThan(permission, GroupPermissionLevel.Write)
            ? props.accessRightWriteTitle
            : (EnumHelper.isEqual(permission, GroupPermissionLevel.Read) ? props.accessRightReadTitle : props.accessRightNoneTitle)) +
            (props.getAdditionalPermissionInUse(permission, 0) && unitNode.permission.additionalPermissionA > 0 ? " + " + props.additionalPermissionTitle[0] : "") +
            (props.getAdditionalPermissionInUse(permission, 1) && unitNode.permission.additionalPermissionB > 0 ? " + " + props.additionalPermissionTitle[1] : "") +
            (props.getAdditionalPermissionInUse(permission, 2) && unitNode.permission.additionalPermissionC > 0 ? " + " + props.additionalPermissionTitle[2] : "");
        return (
            <Box sx={{
                maxHeight: props.isFirstNode ? props.height : "auto",
                overflowX: "hidden",
                overflowY: "auto",
            }}>
                <ListItemButton
                    selected={selectedId === props.unitNode.id}
                    className={(!hasChildren ? " noChilds" : "") + (isRoot ? " root" : "") + (unitNode.getIsDisabled() ? " disabled" : "") + (unitNode.partnerCompanyIds.length > 0 ? " hasPartners" : "")}
                    onClick={this.handleUnitNodeClick}
                    onDoubleClick={this.handleUnitNodeDoubleClick}
                >
                    <Grid container alignItems="center">
                        <Grid item sm={5}>
                            <Box display="flex" alignItems="center" sx={{ paddingLeft: (10 * props.level).toString(10) + "px" }}>
                                {(!isRoot && !props.isFirstNode) &&
                                <>
                                    {hasVisibleChildren
                                        ? (
                                            <ExpandMoreIcon fontSize="small" />
                                        )
                                        : (
                                            <Box sx={{ width: "20px" }} />
                                        )}
                                </>
                                }
                                <HomeIcon sx={{ marginRight: ".5rem" }} />
                                <span className={"icon access level" + Math.min(unitNode.permission.permission, GroupPermissionLevel.Write).toString(10)}></span>
                                <Typography
                                    fontWeight={selectedId === props.unitNode.id ? 600 : 400}
                                    sx={{ marginLeft: ".5rem" }}
                                >
                                    {unitNode.name}
                                </Typography>
                                {unitNode.partnerCompanyIds.length > 0 && <Typography color="error" sx={{ marginLeft: ".5rem" }}>*</Typography>}
                            </Box>
                        </Grid>
                        <Grid item sm={7}>
                            <Box display="flex" className={(unitNode.permission.isExplicitPermission ? "" : " inherited")} onClick={() => this.handleUnitNodeDoubleClick(null)}>
                                {unitNode.permission.isExplicitPermission &&
                                    <ListStateIconTool noMargin />
                                }
                                {permissionText
                                    ? <Typography
                                        fontWeight={selectedId === props.unitNode.id ? 600 : 400}
                                        sx={{ color: unitNode.permission.isExplicitPermission ? "text.primary" : "text.secondary", marginLeft: unitNode.permission.isExplicitPermission ? ".5rem" : 0 }}
                                    >
                                        {permissionText}
                                    </Typography>
                                    : "&nbsp;"}
                            </Box>
                        </Grid>
                    </Grid>
                </ListItemButton>
                {unitNode.children.map((childUnitNode) =>
                    <UnitPermissionTree
                        key={childUnitNode.id}
                        unitNode={childUnitNode}
                        selectedId={selectedId}
                        isFirstNode={false}
                        level={props.level ? (props.level + 1) : 1}
                        accessRightNoneTitle={props.accessRightNoneTitle}
                        accessRightReadTitle={props.accessRightReadTitle}
                        accessRightWriteTitle={props.accessRightWriteTitle}
                        additionalPermissionTitle={props.additionalPermissionTitle}
                        getAdditionalPermissionInUse={props.getAdditionalPermissionInUse}
                        onClick={props.onClick}
                        onOpen={props.onOpen}
                    />
                )}
            </Box>
        );
    }
}